import { MenuEnum, MenuPathEnum } from './Header.enum'

export const HEADER_NAVIGATION = [
  { path: MenuPathEnum.ACCOUNT, name: MenuEnum.ACCOUNT },
  { path: MenuPathEnum.ORDERS, name: MenuEnum.ORDERS },
  { path: MenuPathEnum.SERVICES, name: MenuEnum.SERVICES },
  { path: MenuPathEnum.BAG, name: MenuEnum.BAG },
  { path: MenuPathEnum.MENU, name: MenuEnum.MENU },
]
